import React, {createContext, useContext, useState} from 'react';
import AuthService from "../services/AuthService";
import {PMSPharmacyContext} from "./pms_contexts/PMSPharmacyContext";
import {PMSConfigContext} from "./pms_contexts/PMSConfigContextProvider";
import {AFFILIATE_LOGIN} from "../helpers/Constants";

export const AffiliateAuthContext = createContext("AffiliateAuthContext");

const auth = localStorage.getItem(AFFILIATE_LOGIN);
let permissions_ = localStorage.getItem("oushodsheba_permissions");
let appType_ = localStorage.getItem("appType");
permissions_ = permissions_ ? JSON.parse(permissions_) : [];

const AffiliateAuthContextProvider = ({children}) => {

    const pmsPharmacyContext = useContext(PMSPharmacyContext);
    const pmsConfigContext = useContext(PMSConfigContext);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [isAffLogin, setIsAffLogin] = useState(!!auth);
    const [permissions, setPermissions] = useState([...permissions_, 'ALL']);
    const [appType, setAppType] = useState(appType_);

    const logoutRequest = () => {
        setIsAffLogin(false);
        localStorage.removeItem("selectedPharmacy");
        localStorage.removeItem(AFFILIATE_LOGIN);
        localStorage.removeItem("oushodsheba_permissions");
        localStorage.removeItem("appType");
        localStorage.removeItem("printing_config");
        pmsPharmacyContext.setSelectedPharmacy(null);
        // localStorage.clear();
    }


    const affiliateLoginRequest = async (data, isPharmacist = false, adminLogin = false) => {
        try {
            setLoading(true);
            setErrorMsg("");
            const res = await AuthService.affiliatelogin(data, isPharmacist);
            localStorage.setItem(AFFILIATE_LOGIN, res.data.token.access);
            let moduleBasePermissions = res.data.moduleBasePermissions;

            // if (adminLogin) {
            //     setAppType(AppType.OS);
            //     localStorage.setItem("appType", AppType.OS);
            // } else {
            //     setAppType(AppType.PMS);
            //     localStorage.setItem("appType", AppType.PMS);
            // }
            //
            // if (isPharmacist) {
            //     localStorage.setItem("selectedPharmacy", JSON.stringify(res.data.liteUserDTO.pharmacy));
            //     pmsPharmacyContext.setSelectedPharmacy(res.data.liteUserDTO.pharmacy);
            //     pmsConfigContext.getPMSPrintingConfigByPharmacyId(res.data.liteUserDTO.pharmacy.id);
            // }

            let permissionList = [];

            for (let e in moduleBasePermissions) {
                permissionList.push(e);
                moduleBasePermissions[e].forEach(p => {
                    permissionList.push(p.name);
                });
            }

            setPermissions(permissionList);
            localStorage.setItem("oushodsheba_permissions", JSON.stringify(permissionList));

            setIsAffLogin(true);
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);
            const message = error.response ? error.response.data.message : error.message
            setErrorMsg(message);
            return false;
        }

    }


    return (
        <AffiliateAuthContext.Provider
            value={{
                loading,
                errorMsg,
                isAffLogin,
                appType,
                logoutRequest,
                permissions,
                affiliateLoginRequest
            }}
        >
            {children}
        </AffiliateAuthContext.Provider>
    );
}

export default AffiliateAuthContextProvider;